import { Component, Mixins, Watch } from "vue-property-decorator";
import { Line, mixins } from "vue-chartjs";
import {
  CANVAS_COLOR_PLUGIN,
  LABEL_CHART_DRAW,
  generalOptions
} from "../../../constants/AdminDashboardConstants";
import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";
import { ChartOptions } from "chart.js";

const { reactiveProp } = mixins;

@Component({
  name: "LineChart"
})
export default class LineChart extends Mixins(Line, reactiveProp) {
  options: ChartOptions = {
    ...generalOptions,
    onClick: this.handleClick,
    plugins: {
      datalabels: {
        backgroundColor: function(context) {
          /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
          return context.dataset.backgroundColor as any;
        },
        borderColor: "white",
        borderRadius: 20,
        borderWidth: 2,
        anchor: "end",
        color: "white",
        font: {
          weight: "bold"
        },
        padding: 7
      }
    }
  };

  mounted() {
    this.addPlugin(ChartJSPluginDatalabels);
    this.addPlugin(CANVAS_COLOR_PLUGIN);
    this.addPlugin(LABEL_CHART_DRAW);
    this.setGradient();
    this.renderChart(this.chartData, this.options);
  }

  setGradient() {
    const canvas = document.getElementById("line-chart") as HTMLCanvasElement;
    const context = canvas.getContext("2d");
    const gradient = context?.createLinearGradient(0, 0, 0, 450);

    gradient?.addColorStop(0, "rgba(99, 199, 231, 1)");
    gradient?.addColorStop(0.5, "rgba(99, 199, 231, 0.5)");
    gradient?.addColorStop(1, "rgba(99, 199, 231, 0)");

    this.chartData.datasets?.forEach(data => {
      data.backgroundColor = gradient;
      data.borderColor = "#63c7e7";
      data.pointBackgroundColor = "#63c7e7";
    });
  }

  handleClick(point: MouseEvent, event: { _index: number }[]) {
    if (event.length === 0) {
      this.$emit("chartClickOut", true);
    } else if (event[0]) {
      const index = event[0]._index;
      const label = (this.chartData.labels as string[] | number[])[index];
      this.$emit("chartClick", label);
    }
  }

  @Watch("chartData")
  updateChart() {
    this.setGradient();
    this.renderChart(this.chartData, this.options);
  }
}
